import { Link } from "react-router-dom";
import { Check, Info, Sparkle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../i18n/translations";
import { Reveal, SectionHeading, PerBadge } from "../components/ui-bits";

const arrangements = [
  { key: "a1", price: "€43", img: IMAGES.food1, testid: "arrangement-card-vlaams", allin: true },
  { key: "a2", price: "€43", img: IMAGES.food3, testid: "arrangement-card-italiaans", allin: true },
  { key: "a3", price: "€52", img: IMAGES.food2, testid: "arrangement-card-koud-buffet", min8: true, allin: true },
  { key: "a4", price: "€52", img: IMAGES.steengrill, testid: "arrangement-card-steengrill", allin: true },
];

export default function Arrangementen() {
  const { t } = useLanguage();
  return (
    <main className="pt-32 pb-10 theme-green">
      <section className="max-w-7xl mx-auto px-5" data-testid="arrangements-section">
        <SectionHeading eyebrow="Helios" title={t("arrangements.title")} sub={t("arrangements.sub")} />

        <Reveal>
          <div className="mb-12 text-center" data-testid="arrangements-per-person-banner">
            <span className="inline-block font-disco text-2xl sm:text-4xl gold-text border border-[#F0C971]/50 rounded-full px-10 py-4 bg-[#F0C971]/5 shadow-[0_0_40px_rgba(240,201,113,0.15)]">
              {t("arrangements.banner")}
            </span>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-8">
          {arrangements.map((a, i) => {
            const data = t(`arrangements.${a.key}`);
            return (
              <Reveal key={a.key} delay={i * 0.08}>
                <article data-testid={a.testid} className="glass glow-card rounded-3xl overflow-hidden h-full flex flex-col">
                  <div className="relative h-56 overflow-hidden group">
                    <img src={a.img} alt={data.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E17] to-transparent" />
                    <span className="absolute top-4 left-4 font-display text-xs tracking-[0.3em] uppercase text-[#F0C971] bg-[#05070B]/70 px-3 py-1 rounded-full border border-[#F0C971]/40">
                      {data.tag}
                    </span>
                    {a.min8 && (
                      <span className="absolute top-4 right-4 text-xs font-bold text-[#05070B] bg-[#F0C971] px-3 py-1 rounded-full">
                        {t("arrangements.min8")}
                      </span>
                    )}
                  </div>
                  <div className="p-8 flex-1 flex flex-col">
                    <div className="flex items-end justify-between gap-4 flex-wrap">
                      <h3 className="font-display text-3xl sm:text-4xl uppercase neon">{data.name}</h3>
                      <div className="text-right">
                        <span className="font-disco text-4xl gold-text">{a.price}</span>
                        <div className="mt-1"><PerBadge>{t("arrangements.perPerson")}</PerBadge></div>
                      </div>
                    </div>
                    <p className="mt-6 font-display text-sm tracking-[0.3em] uppercase text-[#00F0FF]">{t("arrangements.includes")}</p>
                    <ul className="mt-3 space-y-2 flex-1">
                      {data.items.map((item, j) => (
                        <li key={j} className="flex gap-2 text-sm text-[#9db8d6]">
                          <Check size={15} className="text-[#00F0FF] shrink-0 mt-0.5" /> {item}
                        </li>
                      ))}
                    </ul>
                    {a.allin && (
                      <div className="mt-6 rounded-xl border border-[#F0C971]/40 bg-[#F0C971]/5 p-4" data-testid={`${a.testid}-allin`}>
                        <p className="font-display text-lg tracking-widest uppercase gold-text flex items-center gap-2">
                          <Sparkle size={16} className="text-[#F0C971]" /> {t("arrangements.allin")} +€25 {t("arrangements.perPerson")}
                        </p>
                        <p className="text-xs text-[#9db8d6] mt-1">{t("arrangements.allinText")}</p>
                      </div>
                    )}
                    <Link to="/reserveer" data-testid={`${a.testid}-cta`} className="btn-ghost mt-7 font-display text-center tracking-[0.2em] uppercase px-8 py-3 rounded-full">
                      {t("arrangements.cta")}
                    </Link>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 glass rounded-2xl p-8 flex gap-4 items-start" data-testid="arrangements-deposit-note">
            <Info size={24} className="text-[#F0C971] shrink-0 mt-1" />
            <div>
              <h4 className="font-display text-xl tracking-widest uppercase text-[#F0C971]">{t("arrangements.depositTitle")}</h4>
              <p className="text-sm text-[#9db8d6] mt-2 leading-relaxed">{t("arrangements.depositText")}</p>
            </div>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
